import { Controller } from '@hotwired/stimulus';
import { dayjs } from '../../../components/dayjs-localized';

export default class extends Controller {
  static targets = [
    'date',
    'endContractToggle',
    'endContractDate',
    'contractStartDate',
    'motive',
    'noticeDate',
    'dependentChildrenDays',
    'splittingDays',
    'endContractFields',
    'lastContractDateText',
  ];

  static values = {
    lastContractStartDate: String,
  };

  connect() {
    $(this.endContractDateTarget).datetimepicker('option', 'dateFormat', 'YYYY-MM-DD');
    if (this.hasNoticeDateTarget) {
      $(this.noticeDateTarget).datetimepicker('option', 'dateFormat', 'YYYY-MM-DD');
    }
    this.toggleEndContract();
    this.monthChanged();
    this.setNoticeDate();

    // add event on end contract date change as it is controlled by datetimepicker and
    // stimulus events will not work on this input
    $(this.endContractDateTarget).on('changeDate', () => {
      this.setNoticeDate(true);
    });
  }

  toggleEndOfContract() {
    const endOfSimulationMonth = this.date().endOf('month');
    const lastContractStartDate = dayjs(this.lastContractStartDateValue);
    this.lastContractDateTextTarget.hidden = lastContractStartDate < endOfSimulationMonth;
    this.endContractFieldsTarget.hidden = lastContractStartDate >= endOfSimulationMonth;
  }

  setEndOfContractRange() {
    // Set end of contract date field min/max date
    $(this.endContractDateTarget).datetimepicker('setStartDate', this.dateStart());
    $(this.endContractDateTarget).datetimepicker('setEndDate', this.dateEnd());

    // Set notice date field min/max date
    this.setNoticeDate(true);
  }

  setNoticeDate(reset = false) {
    if (this.hasNoticeDateTarget) {
      const endContractDate = $(this.endContractDateTarget).datetimepicker('getDate');
      if (reset) this.noticeDateTarget.value = '';

      if (dayjs(endContractDate) < dayjs(this.dateEnd())) {
        $(this.noticeDateTarget).datetimepicker('setEndDate', endContractDate);
      } else {
        $(this.noticeDateTarget).datetimepicker('setEndDate', this.dateEnd());
      }
    }
  }

  monthsRange() {
    let start = this.firstAvailableMonth();
    const end = dayjs(this.dateEnd());
    const months = [];
    while (end.isAfter(start) || start.month() === end.month()) {
      months.push(start.format('M'));
      start = start.add(1, 'month');
    }
    return months;
  }

  setVacationImpact() {
    const contractStartDate = dayjs(this.contractStartDateTarget.value, 'D/MM/YYYY');
    // the contract has to start before the 1st May
    const contractStartedBefore = contractStartDate.isBefore(dayjs(new Date(dayjs().year(), 4, 1)));
    // we need to make sure that the user has started working before 1 October
    const startedWorkingBefore = contractStartDate.isBefore(dayjs(new Date(dayjs().year(), 9, 1)));

    /**
     * Either the initial contract started before May and either it includes May or the simulation stops on April
     * Or the contracts starts after May and the months simulated includes May
     * *CAREFUL* Be very careful with this condition it may seem easy but think twice
     */
    $(this.dependentChildrenDaysTarget).toggle(
      (contractStartedBefore && (this.date().month() === 3 || this.monthsRange().includes('5'))) ||
        (!contractStartedBefore && this.monthsRange().includes('5'))
    );

    /**
     * Either started working before October and either it includes October or the simulation stops on September
     * Or the contracts starts after October and the months simulated includes October
     * *CAREFUL* Be very careful with this condition it may seem easy but think twice
     */
    $(this.splittingDaysTarget).toggle(
      (startedWorkingBefore && (this.date().month() === 8 || this.monthsRange().includes('10'))) ||
        (!startedWorkingBefore && this.monthsRange().includes('10'))
    );
  }

  /*****
     * @returns {dayjs.Dayjs} the date of the simulation
     ****/
  date() {
    return dayjs(this.dateTarget.value);
  }

  dateStart() {
    return this.date().startOf('month').format('YYYY-MM-DD');
  }

  dateEnd() {
    return this.date().endOf('month').format('YYYY-MM-DD');
  }

  firstAvailableMonth() {
    return dayjs(this.dateTarget.options[0].value);
  }

  toggleEndContract() {
    const element = $('.contract-end-content');
    // special case when we mount the modal the element is displayed but not visible
    if (!element.is(':visible') && element.css('display') === 'block') {
      element.hide();
    } else if (this.endContractToggleTarget.checked !== $(element).is(':visible')) {
      element.slideToggle();
    }
  }

  monthChanged() {
    this.toggleEndOfContract();
    this.setEndOfContractRange();
    this.setVacationImpact();
  }
}
